/* eslint-disable global-require */
module.exports = ((scope) => {
  require('zepto/src/zepto');
  require('zepto/src/event');
  require('zepto/src/ajax');
  require('zepto/src/form');
  require('zepto/src/ie');
  require('zepto/src/fx');
  require('zepto/src/fx_methods');
  require('zepto/src/selector');
  require('../modules/3rdparty/velocity');

  const Zepto = scope.XVXZepto || scope.Zepto;
  const propertiesToChange = [
    'height',
    'margin-top',
    'margin-bottom',
    'padding-top',
    'padding-bottom',
  ];

  /**
   * getObjectValues
   * @param {Array} propertiesList
   * @param {Function} getValue
   * @description reduce a list of properties with their values
   */
  function reducePropertiesValues(propertiesList, getValue) {
    return propertiesList.reduce((properties, propName) => {
      properties[propName] = getValue(propName); // eslint-disable-line  no-param-reassign
      return properties;
    }, {});
  }

  /**
   *
   * @param {Zepto} $target
   * @param {Array} propertiesList
   */
  function removeValues($target, propertiesList) {
    const propertiesWithoutValues = reducePropertiesValues(propertiesList, () => '');
    $target.css(propertiesWithoutValues);
  }

  /**
   *
   * @param {Zepto} $target
   * @param {Array} propertiesList
   * @returns {object}
   */
  function getValues($target, propertiesList) {
    return reducePropertiesValues(propertiesList, $target.css.bind($target));
  }

  /**
   *
   * @param {Array} propertiesList
   */
  function getPropertiesAsZero(propertiesList) {
    return reducePropertiesValues(propertiesList, () => 0);
  }

  /**
   *
   * @param {Zepto} $target
   * @param {Array} propertiesList
   */
  function setPropertiesToZero($target, propertiesList) {
    $target.css(getPropertiesAsZero(propertiesList));
  }

  /**
   *
   * @param {number} duration
   * @param {object} [options={}]
   * @param {boolean} [options.withFade=true]
   */
  function slideDown(duration, options = {}) {
    const { withFade = false, onComplete } = options;
    const $target = this;

    // Removing these properties (in case $target was slided up)
    // to get the real dimensions
    removeValues($target, [
      'display',
    ]);

    // getting the real dimensions of the element
    const values = getValues($target, propertiesToChange);

    // set initial css for animation
    // 1. setting all the vertical properties (and opacitiy if it's needed)
    //    to 0 as starting point.
    // 2. avoiding overflows, so the animation is cleaner
    setPropertiesToZero($target, propertiesToChange);
    if (withFade) {
      $target.css('opacity', 0);
      values.opacity = 1;
    }

    $target.css('overflow', 'hidden');

    function complete() {
      // removing all the css added throught javascript,
      // since is not needed anymore
      removeValues($target, propertiesToChange.concat('overflow', 'opacity'));
      if (onComplete) {
        onComplete();
      }
    }

    $target.animate(values, duration, 'ease', complete);
    return $target;
  }

  /**
   *
   * @param {number} duration
   * @param {boolean} [options.withFade=true]
   * @param {Function} [options.callback]
   */
  function slideUp(duration, options = {}) {
    const { withFade = false, onComplete } = options;
    const $target = this;

    const values = getValues($target, propertiesToChange);
    if (withFade) {
      values.opacity = 1;
    }

    // set initial css for animation
    $target.css(values);

    // avoiding overflows, so the animation is cleaner
    $target.css('overflow', 'hidden');

    function complete() {
      // removing all the css added throught javascript except by display none
      removeValues($target, propertiesToChange.concat('overflow', 'opacity'));

      $target.css('display', 'none');

      if (onComplete) {
        onComplete();
      }
    }

    const newValues = getPropertiesAsZero(propertiesToChange);

    if (withFade) {
      newValues.opacity = 0;
    }

    $target.animate(newValues, duration, 'ease', complete);
    return $target;
  }

  Zepto.fn.isChildOf = function isChildOf(b) {
    return (this.parents(b).length > 0);
  };
  Zepto.fn.slideDown = slideDown;
  Zepto.fn.slideUp = slideUp;

  return Zepto;
})(window);
